import { render, staticRenderFns } from "./DoneCreatingStudy.vue?vue&type=template&id=5d8c63b1&scoped=true&"
import script from "./DoneCreatingStudy.vue?vue&type=script&lang=js&"
export * from "./DoneCreatingStudy.vue?vue&type=script&lang=js&"
import style0 from "./DoneCreatingStudy.vue?vue&type=style&index=0&id=5d8c63b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c63b1",
  null
  
)

export default component.exports